import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const PinterestCircle24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      className={cn(
        chroma === 'default' && s.pinterestFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M12.5 1C18.847 1 24 6.153 24 12.5S18.847 24 12.5 24 1 18.847 1 12.5 6.153 1 12.5 1zm-2.49 6.832c-2.727 1.792-2.115 4.565-2.115 4.565.294 1.769 1.442 2.058 1.442 2.058.226.071.3-.17.3-.17l.183-.748c.022-.095-.064-.194-.064-.194l-.154-.19c-.41-.608-.383-1.37-.383-1.37.104-1.995 1.306-2.821 1.905-3.128.599-.301 2.42-.78 3.742.404 1.321 1.184.62 3.706.62 3.706-.262 1.089-.912 1.753-.912 1.753-.815.77-1.587.42-1.587.42-.89-.389-.695-1.27-.695-1.27l.074-.307.164-.588s.445-1.214.403-1.9c-.042-.682-.515-1.152-1.321-.922-.807.23-.966 1.385-.966 1.385-.13.982.102 1.457.198 1.61l-.01.008-.846 3.696c-.21.93-.21 1.462-.193 2.011.017.55.107 1.102.107 1.102.079.118.173 0 .173 0 .982-1.293 1.22-2.193 1.22-2.193l.55-2.213c.32.536.793.708.793.708 1.745.769 3.26-.693 3.26-.693s1.724-1.4 1.502-4.283c-.218-2.883-2.69-3.701-2.69-3.701-2.71-.995-4.7.444-4.7.444z"
      fillRule="evenodd"
    />
  </svg>
);

export default PinterestCircle24;
